import React from 'react'

export default ({className, value, ...props}) => {
    return (
        <div className="form-group">
            <input {...props}
                   type="submit"
                   value={value}
                   className={`form-control btn btn-block btn-primary ${className}`}/>
        </div>
    )
}
